var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.49,5.57l.72.69L12.7,12l5.54,5.79-.72.69L12,12.74,6.51,18.5l-.73-.69L11.32,12,5.82,6.26l.72-.69L12,11.3Z"}));
}

CloseInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
